import { render } from "./TyreList.vue?vue&type=template&id=1d14d046&scoped=true"
import script from "./TyreList.vue?vue&type=script&lang=js"
export * from "./TyreList.vue?vue&type=script&lang=js"

import "./TyreList.vue?vue&type=style&index=0&id=1d14d046&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d14d046"]])

export default __exports__